import 'core-js/features/reflect';
import '@angular/compiler';

import {bootstrapApplication} from '@angular/platform-browser';
import { setTheme } from 'ngx-bootstrap/utils';
import {AppComponent} from './app.component';
import {appConfig} from './app.config';

// Capture deeper stacks for Rollbar / console before anything else throws.
if (typeof Error !== 'undefined' && (Error as any).stackTraceLimit < 50) {
  (Error as any).stackTraceLimit = 50;
}

// Do not call enableProdMode(): keep ExpressionChanged / NG0100 checks active
// in deploy builds so binding races surface in Rollbar (via ErrorHandler).

setTheme('bs5');

bootstrapApplication(AppComponent, appConfig);
